<app-header #header title="home"></app-header>


<ion-content>
    <app-header-content ></app-header-content>
    <div #contentContainer style="padding: 0.2em;min-height: 75%;margin: 2em;"></div>
    <ion-footer class="ion-no-border">
        <app-footer></app-footer>
    </ion-footer>
</ion-content>